import React from 'react';
import { CreditCard, Layers, MapPin, Hash, FileText, Percent, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function ProductosParametrizacion() {
    const items = [
        { title: 'Línea de Créditos', icon: CreditCard, href: '/parametrizacion/lineas-credito', color: 'bg-teal-700' },
        { title: 'Tipos de Crédito', icon: Layers, href: '/parametrizacion/tipos-credito', color: 'bg-teal-500' },
        { title: 'Destinos de Fondos', icon: MapPin, href: '/parametrizacion/destinos-fondos', color: 'bg-orange-500' },
        { title: 'Tipos de Cuentas (Ahorro)', icon: Hash, href: '/parametrizacion/tipos-cuenta', color: 'bg-indigo-500' },
        { title: 'Estados de Créditos', icon: FileText, href: '/parametrizacion/estados-credito', color: 'bg-gray-600' },
        { title: 'Estados de Cuentas', icon: FileText, href: '/parametrizacion/estados-cuenta', color: 'bg-gray-500' },
        { title: 'Calificación de Riesgo', icon: Percent, href: '/parametrizacion/calificacion-riesgo', color: 'bg-red-500' },
        { title: 'Reglas de Crédito', icon: ShieldCheck, href: '/parametrizacion/reglas-credito', color: 'bg-teal-500' },
        { title: 'Tasas de Interés', icon: Percent, href: '/parametrizacion/tasas', color: 'bg-orange-500' },
        { title: 'Validación de Créditos', icon: ShieldCheck, href: '/parametrizacion/estados-valido-credito', color: 'bg-red-600' },
    ];

    return (
        <div className="p-6">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                <div className="px-6 py-4 flex items-center space-x-4 bg-teal-100 text-teal-800">
                    <CreditCard className="w-8 h-8 opacity-80" />
                    <div>
                        <h3 className="text-xl font-bold">2. Módulo: Configuración de Productos Financieros</h3>
                        <p className="text-sm opacity-90">Este grupo es el corazón del negocio (el "Qué").</p>
                    </div>
                </div>

                <div className="p-6">
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                        {items.map((table, idx) => (
                            <Link
                                key={idx}
                                to={table.href}
                                className="bg-gray-50 text-gray-800 border-gray-100 hover:bg-opacity-90 p-4 rounded-xl shadow-sm hover:shadow-md transition-all border flex flex-col items-center text-center group"
                            >
                                <div className={`p-3 rounded-full ${table.color} bg-opacity-10 mb-3 group-hover:scale-110 transition-transform`}>
                                    <table.icon className={`w-6 h-6 ${table.color.replace('bg-', 'text-')}`} />
                                </div>
                                <h4 className="font-bold text-sm text-gray-800 group-hover:text-blue-600 transition-colors leading-tight">{table.title}</h4>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
